"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxLengthOfDecimalNumber = exports.regexFit = exports.minLengthMinusOffset = exports.maxLengthMinusOffset = void 0;

var _validators = require("@sword-health/vuelidate/lib/validators");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var addParam = function addParam(attributes, callback) {
  return _validators.helpers.withParams(attributes, callback);
};

var regexFit = function regexFit(value, regex) {
  var reg = new RegExp(regex);
  return reg.test(value);
};

exports.regexFit = regexFit;

var maxLengthMinusOffset = function maxLengthMinusOffset(max, offset) {
  var attributes = {
    type: 'maxLength',
    max: max
  };

  var doThis = function doThis(value) {
    if (!value && value !== false) {
      return true;
    }

    return value.toString().length <= max + offset;
  };

  return addParam(attributes, doThis);
};

exports.maxLengthMinusOffset = maxLengthMinusOffset;

var minLengthMinusOffset = function minLengthMinusOffset(min, offset) {
  var attributes = {
    type: 'minLength',
    min: min
  };

  var doThis = function doThis(value) {
    if (!value && value !== false) {
      return true;
    }

    return value.toString().length >= min + offset;
  };

  return addParam(attributes, doThis);
};

exports.minLengthMinusOffset = minLengthMinusOffset;

var maxLengthOfDecimalNumber = function maxLengthOfDecimalNumber(integerMax, fractionalMax) {
  var attributes = {
    type: 'maxLength'
  };

  var doThis = function doThis(value) {
    if (!value && value !== false) {
      return true;
    }

    var _$split = "".concat(value).split('.'),
        _$split2 = _slicedToArray(_$split, 2),
        integer = _$split2[0],
        fractional = _$split2[1];

    return integer.length <= integerMax && fractional.length <= fractionalMax;
  };

  return addParam(attributes, doThis);
};

exports.maxLengthOfDecimalNumber = maxLengthOfDecimalNumber;